import { Button, Form, InputNumber, Select, Table, Tooltip } from "antd";
import ConfirmDelete from "components/Global/confirmDeleteModel";
import { useEffect, useState } from "react";
import { getApi, postApi, putApi } from "redux/apis";
import { DeleteActionSvg } from "utils/svgs";
import { capitalizeFirstLetter, toastText } from "utils/utils";
import { invalidText } from "utils/utils";
import PalletTypeModal from "../PalletTypeModal";
import SearchAndFilter from "../SearchAndFilter";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

const checkForMissingValues = (data: any) => {
  return data.map((row: any) => {
    const isItemError = !row.itemName || !row.itemId;
    const isQuantityError = invalidText(row.quantity);
    const isContainerTypeError =
      !row.containerType || invalidText(row.containerType);

    return {
      ...row,
      isItemError,
      isQuantityError,
      isContainerTypeError,
    };
  });
};
const ShippingModal = (props: any) => {
  const { packageId, isOpen, handleShippingCancel } = props;

  const navigate = useNavigate();

  // Track original weights for pallets
  const [originalWeights, setOriginalWeights] = useState<{
    [key: string]: number;
  }>({});
  // Track manually edited weights for mixed pallets to preserve them
  const [manuallyEditedWeights, setManuallyEditedWeights] = useState<{
    [key: string]: number;
  }>({});
  // Track manually edited weights for regular pallets separately
  const [manuallyEditedPalletWeights, setManuallyEditedPalletWeights] =
    useState<{
      [key: string]: number;
    }>({});
  const [isPalletTypeModalOpen, setIsPalletTypeModalOpen] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [palletsLoading, setPalletsLoading] = useState(false);
  const [palletCounter, setPalletCounter] = useState(1);
  const [customBoxCounter, setCustomBoxCounter] = useState(4);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [selectedShipping, setSelectedShipping] = useState<any>(null);
  const [isOrderStatusModalOpen, setIsOrderStatusModalOpen] = useState(false);
  const [totalWeight, setTotalWeight] = useState([]);
  const [totalWeightChange, setTotalWeightChange] = useState(false);
  const [items, setItems] = useState<
    Array<{
      name: string;
      id: number;
      quantity: number;
      listID: string;
      modelName: string;
    }>
  >([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<any>([]);
  const [finalItemStatus, setFinalItemStatus] = useState<any>([]);

  const [isSaveAndDraftLoading, setIsSaveAndDraftLoading] = useState(false);
  const [isCreatePackingLoading, setIsCreatePackingLoading] = useState(false);

  const [isDiscrepancyModalOpen, setIsDiscrepancyModalOpen] = useState(false);
  const [discrepancies, setDiscrepancies] = useState<string[]>([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [usedBoxesByPallet, setUsedBoxesByPallet] = useState({});

  //  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => setIsPalletTypeModalOpen(true);
  const closeModal = () => setIsPalletTypeModalOpen(false);
  const getUsedBoxesForPallet = (palletName) => {
    return tableData
      .filter(
        (item) =>
          item.palletName === palletName &&
          item.containerType === "BOX" &&
          item.containerTypeName &&
          !item.isDimensionsRow
      )
      .map((item) => item.containerTypeName);
  };
  const reorderItemHandler = (pallets: any[]) => {
    // Separate regular and mixed pallets
    const regularPallets = pallets.filter((p) => p.palletType === "PALLET");
    const mixedPallets = pallets.filter((p) => p.palletType !== "PALLET");

    // Calculate item totals and remaining items for each item
    const itemTotals = {};

    // Group all pallets (both regular and mixed) by itemId to calculate totals
    pallets.forEach((pallet) => {
      if (!pallet.itemId) return;

      if (!itemTotals[pallet.itemId]) {
        itemTotals[pallet.itemId] = {
          totalQuantity: 0,
          soQuantity: pallet.soQuantity,
        };
      }

      // Add this pallet's quantity to the total
      itemTotals[pallet.itemId].totalQuantity +=
        (pallet.quantity || 0) * (pallet.quantityPerBox || 1);
    });

    // Calculate remaining items for each itemId
    Object.keys(itemTotals).forEach((itemId) => {
      itemTotals[itemId].remainingItems = Math.max(
        itemTotals[itemId].soQuantity - itemTotals[itemId].totalQuantity,
        0
      );
    });

    // Group regular pallets by item name
    const groupedPallets = regularPallets.reduce((groups: any, pallet: any) => {
      if (!groups[pallet.itemName]) {
        groups[pallet.itemName] = [];
      }
      groups[pallet.itemName].push(pallet);
      return groups;
    }, {});

    // Sort each group and rename them sequentially
    let palletCounter = 1;
    const reorderedPallets = Object.values(groupedPallets)
      .map((group: any) =>
        group.sort((a, b) => a.palletName.localeCompare(b.palletName))
      )
      .flat()
      .map((pallet: any) => {
        const itemTotal = itemTotals[pallet.itemId];

        return {
          ...pallet,
          palletName: `Pallet ${palletCounter++}`,
          remainingItems: itemTotal ? itemTotal.remainingItems : 0,
        };
      });

    // Update remainingItems for mixed pallets
    const updatedMixedPallets = mixedPallets.map((pallet: any) => {
      const itemTotal = itemTotals[pallet.itemId];

      return {
        ...pallet,
        remainingItems: itemTotal ? itemTotal.remainingItems : 0,
      };
    });

    return [...reorderedPallets, ...updatedMixedPallets];
  };

  // const calculateItemTotals = (pallets: any[]) => {
  //   // Group pallets by itemId and calculate totals
  //   const itemTotals = pallets.reduce((totals: any, pallet: any) => {
  //     if (!pallet.itemId) return totals;

  //     if (!totals[pallet.itemId]) {
  //       totals[pallet.itemId] = {
  //         totalQuantity: 0,
  //         soQuantity: pallet.soQuantity,
  //       };
  //     }

  //     // Add this pallet's quantity to the total
  //     totals[pallet.itemId].totalQuantity +=
  //       pallet.quantity * pallet.quantityPerBox || 0;

  //     return totals;
  //   }, {});

  //   return itemTotals;
  // };

  // Add New Pallet or Mix Pallet from modal
  const onSavePalletType = (selectedType: string) => {
    const newId = Date.now();

    const defaultDimensions = {
      id: `dim-${newId}`,
      palletLength: 0,
      palletWidth: 0,
      palletHeight: 0,
      palletWeight: 0,
    };

    // Calculate next number to use for mixed pallets
    let nextMixedPalletNumber = 1;

    if (selectedType === "MIXPALLET") {
      // Extract pallet numbers from existing mixed pallets
      const mixedPalletNumbers = tableData
        .filter((pallet) => pallet.palletType === "MIXPALLET")
        .map((pallet) => {
          const match = pallet.palletName.match(/Mixed Pallet (\d+)/);
          return match ? parseInt(match[1], 10) : 0;
        });

      // Set the next number to one more than the highest
      nextMixedPalletNumber =
        mixedPalletNumbers.length > 0 ? Math.max(...mixedPalletNumbers) + 1 : 1;
    }

    const palletName =
      selectedType === "PALLET"
        ? `Pallet ${palletCounter}`
        : `Mixed Pallet ${nextMixedPalletNumber}`;

    const newRow = {
      id: newId,
      palletName,
      itemName: "",
      soQuantity: 0,
      modelName: "",
      palletType: selectedType,
      containerType: "",
      quantity: 0,
      quantityPerBox: 0,
      totalQuantity: 0,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      remainingItems: 0,
      palletDimensions: defaultDimensions,
      isDimensionsRow: false,
    };

    const _data = reorderItemHandler([...tableData, newRow]);

    // Apply validation to ensure proper disabling of duplicate combinations
    const validatedData = validateDuplicatePalletContainerTypes(_data);

    setTableData(validatedData);

    if (selectedType === "PALLET") {
      setPalletCounter((prev) => prev + 1);
    }
    // No need to update mixedPalletCounter since we removed it

    collapseAllRows();
    setIsPalletTypeModalOpen(false);
  };

  // Add New Pallet with "PALLET" type
  const createNewPallet = (record: any) => {
    const newRow = {
      id: Date.now(),
      palletName: `Pallet ${palletCounter}`,
      palletType: "PALLET",
      itemName: record.itemName,
      itemId: record.itemId,
      soQuantity: record.soQuantity,
      modelName: record.modelName,
      containerType: "",
      quantity: 0,
      quantityPerBox: 0,
      totalQuantity: 0,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      remainingItems: record.remainingItems,
      palletDimensions: null,
      isDimensionsRow: false,
    };

    const lastPallet = getLastPalletByItem(tableData, record.itemId);
    const lastPalletIndex = lastPallet
      ? tableData.findIndex((row) => row.id === lastPallet.id)
      : -1;

    let newTableData;
    if (lastPalletIndex >= 0) {
      newTableData = [
        ...tableData.slice(0, lastPalletIndex + 1),
        newRow,
        ...tableData.slice(lastPalletIndex + 1),
      ];
    } else {
      newTableData = [...tableData, newRow];
    }

    const _data = reorderItemHandler(newTableData);

    // Apply validation to ensure proper disabling of duplicate combinations
    const validatedData = validateDuplicatePalletContainerTypes(_data);

    // const reorderedData = reorderPalletsByItem(newTableData);
    collapseAllRows();
    setTableData(validatedData);
    setPalletCounter((prev) => prev + 1);
  };

  const handleItemChange = async (value: string, record: any) => {
    const selectedItem = items.find((item: any) => item.id === value);
    if (selectedItem) {
      // Clear manually edited weight for this pallet since item is changing
      // Handle both pallet types independently
      if (record.palletType === "MIXPALLET") {
        setManuallyEditedWeights((prev) => {
          const updated = { ...prev };
          delete updated[record.palletName];
          return updated;
        });
      } else {
        // Clear manually edited weight for regular pallets independently
        setManuallyEditedPalletWeights((prev) => {
          const updated = { ...prev };
          delete updated[record.palletName];
          return updated;
        });
      }

      const _tableData = tableData.map((item) => {
        if (item.id === record.id) {
          // If this row has disableContainerType flag, keep the existing container settings
          if (item.disableContainerType) {
            return {
              ...item,
              itemId: value,
              itemName: selectedItem.name,
              soQuantity: selectedItem.quantity,
              modelName: selectedItem.modelName,
              // Keep existing container settings
              containerType: "BOX",
              containerTypeName: item.containerTypeName,
              // Keep existing dimensions
              length: item.length,
              width: item.width,
              height: item.height,
              weight: item.weight,
              quantityPerBox: item.quantityPerBox,
              // Reset quantity
              quantity: 0,
              totalQuantity: 0,
              remainingItems: 0,
              isItemError: false,
            };
          } else {
            // Original behavior for regular rows

            return {
              ...item,
              itemId: value,
              itemName: selectedItem.name,
              soQuantity: selectedItem.quantity,
              modelName: selectedItem.modelName,
              containerType: null,
              quantity: 0,
              quantityPerBox: 0,
              totalQuantity: 0,
              length: 0,
              width: 0,
              height: 0,
              weight: 0,
              remainingItems: 0,
              isItemError: selectedItem.name ? false : true,
            };
          }
        } else {
          return item;
        }
      });
      const _data = reorderItemHandler(_tableData);

      // Apply validation to ensure proper disabling of duplicate combinations
      const validatedData = validateDuplicatePalletContainerTypes(_data);

      // Calculate total weight AFTER validation is applied
      const mixPalletData = validatedData.filter(
        (item) => item.palletType === "MIXPALLET"
      );
      if (mixPalletData.length > 0) {
        const directArray = _.map(
          _.groupBy(mixPalletData, "palletName"),
          (items, palletName) => _.sumBy(items, "weight")
        );
        setTotalWeight(directArray);
      }

      setTableData(validatedData);
    }
  };

  const handleContainerTypeChange = async (value: string, record: any) => {
    try {
      setPalletsLoading(true);

      // Clear manually edited weight for this pallet since container type is changing
      // Handle both pallet types independently
      if (record.palletType === "MIXPALLET") {
        setManuallyEditedWeights((prev) => {
          const updated = { ...prev };
          delete updated[record.palletName];
          return updated;
        });
      } else {
        // Clear manually edited weight for regular pallets independently
        setManuallyEditedPalletWeights((prev) => {
          const updated = { ...prev };
          delete updated[record.palletName];
          return updated;
        });
      }

      if (value === "ITEM" || value === "MASTERCARTON") {
        const response = await getApi(`/shipping/item-dimensions`, {
          itemId: record.itemId,
          type: value,
        });

        if (response.data.data) {
          const dimensions = response.data.data;

          const existingPalletDimensions = tableData
            .filter(
              (item) =>
                item.palletName === record.palletName &&
                item.palletType === "MIXPALLET"
            )
            .map((item) => item.palletDimensions)[0];

          const _tableData = tableData.map((item) => {
            if (item.id === record.id) {
              return {
                ...item,
                quantityPerBox: dimensions.boxQuantity,
                totalQuantity: dimensions.boxQuantity * item.quantity,
                length: dimensions.length,
                weight: dimensions.weight,
                width: dimensions.width,
                height: dimensions.height,
                // For mixed pallets, preserve the existing pallet dimensions
                palletDimensions:
                  item.palletType === "MIXPALLET"
                    ? existingPalletDimensions
                    : dimensions.palletDimensions,
                containerType: value,
                containerTypeName: null,
                isContainerTypeError: value ? false : true,
                totalWeight: dimensions.weight * (item.quantity || 1),
                hasBeenModified: item.isClone ? true : item.hasBeenModified,
              };
            } else {
              return item;
            }
          });
          // setInitialLoad(true);

          // Apply validation to ensure proper disabling of duplicate combinations
          const validatedData =
            validateDuplicatePalletContainerTypes(_tableData);

          // Calculate total weight AFTER validation is applied
          const mixPalletData = validatedData.filter(
            (item) => item.palletType === "MIXPALLET"
          );
          if (mixPalletData.length > 0) {
            const directArray = _.map(
              _.groupBy(mixPalletData, "palletName"),
              (items, palletName) => {
                // Sum weights from enabled items only, but preserve original weights
                return _.sumBy(items, (item) => {
                  // Skip disabled duplicates in weight calculation
                  if (item.disableContainerType || item.disableDimensions) {
                    return 0;
                  }

                  // For BOX type, use the weight as is (no quantity multiplication)
                  if (item.containerType === "BOX") {
                    return parseFloat(item.weight || 0);
                  }

                  // For MASTERCARTON, multiply weight by quantity
                  if (item.containerType === "MASTERCARTON") {
                    return (
                      parseFloat(item.weight || 0) *
                      parseInt(item.quantity || 0)
                    );
                  }

                  // For ITEM, multiply weight by quantity
                  if (item.containerType === "ITEM") {
                    return (
                      parseFloat(item.weight || 0) *
                      parseInt(item.quantity || 0)
                    );
                  }

                  // Default fallback
                  return (
                    parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                  );
                });
              }
            );
            setTotalWeight(directArray);
          }

          setTableData(validatedData);
        }
      } else {
        const _tableData = tableData.map((item) => {
          if (item.id === record.id) {
            const updatedItem = {
              ...item,
              quantityPerBox: 0,
              totalQuantity: 0,
              length: 0,
              width: 0,
              height: 0,
              weight: 0,
              containerType: "BOX",
              containerTypeName: value,
              isContainerTypeError: item.id ? false : true,
            };
            if (item.isClone) {
              updatedItem.disableContainerType = false;
              updatedItem.disableDimensions = false;
              updatedItem.hasBeenModified = true; // Mark as modified
            }

            return updatedItem;
          } else {
            return item;
          }
        });

        // Apply validation to ensure proper disabling of duplicate combinations
        const validatedData = validateDuplicatePalletContainerTypes(_tableData);

        // Calculate total weight AFTER validation is applied
        const mixPalletData = validatedData.filter(
          (item) => item.palletType === "MIXPALLET"
        );
        if (mixPalletData.length > 0) {
          const directArray = _.map(
            _.groupBy(mixPalletData, "palletName"),
            (items, palletName) => {
              // Sum weights from enabled items only
              return _.sumBy(items, (item) => {
                // Skip disabled duplicates in weight calculation
                if (item.disableContainerType || item.disableDimensions) {
                  return 0;
                }

                // For BOX type, use the weight as is (no quantity multiplication)
                if (item.containerType === "BOX") {
                  return parseFloat(item.weight || 0);
                }

                // For MASTERCARTON, multiply weight by quantity
                if (item.containerType === "MASTERCARTON") {
                  return (
                    parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                  );
                }

                // For ITEM, multiply weight by quantity
                if (item.containerType === "ITEM") {
                  return (
                    parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                  );
                }

                // Default fallback
                return (
                  parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                );
              });
            }
          );
          setTotalWeight(directArray);
        }

        setTableData(validatedData);
      }
    } catch (err) {
      console.log("Something went wrong in fetching dimensions: ", err);
    } finally {
      setPalletsLoading(false);
    }
  };

  const handleQuantityChange = (value: number, record: any) => {
    // Clear manually edited weight for this pallet since quantity is changing
    // Handle both pallet types independently
    // EXCEPT for BOX container type where total weight is independent of quantity
    if (record.palletType === "MIXPALLET" && record.containerType !== "BOX") {
      setManuallyEditedWeights((prev) => {
        const updated = { ...prev };
        delete updated[record.palletName];
        return updated;
      });
    } else if (record.palletType === "PALLET") {
      // Clear manually edited weight for regular pallets independently
      setManuallyEditedPalletWeights((prev) => {
        const updated = { ...prev };
        delete updated[record.palletName];
        return updated;
      });
    }

    // Calculate total quantity for this record
    const totalQty = (value || 0) * (record.quantityPerBox || 0);

    // Calculate the total quantity for all OTHER pallets with the same itemId
    const itemTotal = tableData
      .filter(
        (_pallet) =>
          _pallet.itemId === record.itemId && _pallet.id !== record.id
      )
      .reduce(
        (sum, pallet) =>
          sum + (pallet.quantity || 0) * (pallet.quantityPerBox || 1),
        0
      );

    // Calculate remaining items after all allocations
    const totalAllocated = itemTotal + totalQty;
    const remainingItems = Math.max(record.soQuantity - totalAllocated, 0);

    // Update all pallets with this itemId to show the correct remaining items
    const updatedData = tableData.map((_pallet) => {
      if (_pallet.id === record.id) {
        return {
          ..._pallet,
          quantity: value || 0,
          totalQuantity: totalQty,
          remainingItems: remainingItems,
          isQuantityError: false,
        };
      }

      // For all other pallets with the same itemId, update the remaining items
      if (_pallet.itemId === record.itemId) {
        return {
          ..._pallet,
          remainingItems: remainingItems,
        };
      }

      return _pallet;
    });

    // Update the total weight calculation - only for MIXPALLET types
    const mixPalletData = updatedData.filter(
      (item) => item.palletType === "MIXPALLET"
    );
    if (mixPalletData.length > 0) {
      const directArray = _.map(
        _.groupBy(mixPalletData, "palletName"),
        (items, palletName) => {
          // Sum weights from enabled items only
          return _.sumBy(items, (item) => {
            // Skip disabled duplicates in weight calculation
            if (item.disableContainerType || item.disableDimensions) {
              return 0;
            }

            // For BOX type, use the weight as is (no quantity multiplication)
            if (item.containerType === "BOX") {
              return parseFloat(item.weight || 0);
            }

            // For MASTERCARTON, multiply weight by quantity
            if (item.containerType === "MASTERCARTON") {
              return (
                parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
              );
            }

            // For ITEM, multiply weight by quantity
            if (item.containerType === "ITEM") {
              return (
                parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
              );
            }

            // Default fallback
            return parseFloat(item.weight || 0) * parseInt(item.quantity || 0);
          });
        }
      );
      setTotalWeight(directArray);
    }

    setTableData(updatedData);
  };
  const deleteHandler = () => {
    if (selectedShipping) {
      setIsDeleteLoading(true);

      let filteredData;

      // Check if the selected pallet is a parent with clones
      const isParent = selectedShipping.hasClones;

      // Check if the selected pallet is a clone itself
      const isClone = selectedShipping.isClone;

      if (isParent) {
        // If it's a parent, we need to be more selective about which clones to delete
        // Only delete clones that are still truly dependent (haven't been independently modified)

        // Get all items that reference this parent
        const childClones = tableData.filter(
          (item) => item.parentId === selectedShipping.id
        );

        // Separate dependent clones from independent ones
        const dependentClones = childClones.filter(
          (clone) =>
            !clone.hasBeenModified &&
            clone.containerTypeName === selectedShipping.containerTypeName
        );

        const independentClones = childClones.filter(
          (clone) =>
            clone.hasBeenModified ||
            clone.containerTypeName !== selectedShipping.containerTypeName
        );

        // Remove the parent and only the dependent clones
        const dependentCloneIds = dependentClones.map((clone) => clone.id);
        filteredData = tableData.filter(
          (row) =>
            row.id !== selectedShipping.id &&
            !dependentCloneIds.includes(row.id)
        );

        // For independent clones, remove their parent relationship since the parent is being deleted
        filteredData = filteredData.map((item) => {
          if (independentClones.some((clone) => clone.id === item.id)) {
            return {
              ...item,
              parentId: null,
              isClone: false,
              disableContainerType: false, // Enable them since they're now independent
              // Keep hasBeenModified flag as is
            };
          }
          return item;
        });
      } else if (isClone) {
        // If it's a clone, just remove this specific clone
        filteredData = tableData.filter(
          (row) => row.id !== selectedShipping.id
        );

        // Check if this was the last clone for its parent
        const parentId = selectedShipping.parentId;

        if (parentId) {
          // Count how many clones remain for this parent (including independent ones)
          const remainingClones = filteredData.filter(
            (item) => item.parentId === parentId
          ).length;

          // Count how many dependent clones remain (ones that still share the same container type)
          const remainingDependentClones = filteredData.filter(
            (item) =>
              item.parentId === parentId &&
              !item.hasBeenModified &&
              item.containerTypeName ===
                filteredData.find((p) => p.id === parentId)?.containerTypeName
          ).length;

          // Update the parent based on remaining clone types
          filteredData = filteredData.map((item) => {
            if (item.id === parentId) {
              if (remainingClones === 0) {
                // No clones at all remain
                return {
                  ...item,
                  disableContainerType: false,
                  hasClones: false,
                };
              } else if (remainingDependentClones === 0) {
                // Only independent clones remain, so parent can be enabled
                return {
                  ...item,
                  disableContainerType: false,
                  hasClones: true, // Still has clones, but they're independent
                };
              }
              // Still has dependent clones, keep disabled
              return item;
            }
            return item;
          });
        }
      } else {
        // Regular pallet with no parent/child relationship, just remove it
        filteredData = tableData.filter(
          (row) => row.id !== selectedShipping.id
        );
      }

      // Track which itemIds need their remaining items recalculated
      const affectedItemId = selectedShipping.itemId;

      // Updated handling for pallet renumbering after deletion
      let palletCount = 1;
      const mixedPalletNames = new Map(); // Track mixed pallet names to preserve grouping
      let nextMixedPalletNumber = 1;

      // First pass: identify unique mixed pallet names and determine next number to use
      filteredData.forEach((item) => {
        if (item.palletType === "MIXPALLET") {
          if (!mixedPalletNames.has(item.palletName)) {
            mixedPalletNames.set(
              item.palletName,
              `Mixed Pallet ${nextMixedPalletNumber++}`
            );
          }
        }
      });

      // Second pass: rename pallets and recalculate remaining items for affected item
      let updatedData = filteredData.map((item: any) => {
        // Rename pallet
        const updatedItem = { ...item };

        if (item.palletType === "PALLET") {
          updatedItem.palletName = `Pallet ${palletCount++}`;
        } else if (item.palletType === "MIXPALLET") {
          // Keep items in the same mixed pallet group together
          updatedItem.palletName =
            mixedPalletNames.get(item.palletName) || item.palletName;
        }

        return updatedItem;
      });

      // Third pass: recalculate remaining items for all affected pallets
      // Only do this if the deleted pallet had an itemId and quantity
      if (affectedItemId && selectedShipping.quantity > 0) {
        // Calculate total allocated quantity for this item across all remaining pallets
        const totalAllocated = updatedData
          .filter((pallet) => pallet.itemId === affectedItemId)
          .reduce(
            (sum, pallet) =>
              sum + (pallet.quantity || 0) * (pallet.quantityPerBox || 1),
            0
          );

        // Get the SO quantity from any remaining pallet with this itemId
        const soQuantity =
          updatedData.find((pallet) => pallet.itemId === affectedItemId)
            ?.soQuantity || 0;

        // Calculate remaining items
        const remainingItems = Math.max(soQuantity - totalAllocated, 0);

        // Update remaining items for all pallets with this itemId
        updatedData = updatedData.map((pallet) => {
          if (pallet.itemId === affectedItemId) {
            return {
              ...pallet,
              remainingItems: remainingItems,
            };
          }
          return pallet;
        });
      }

      // FIXED: Always update the total weight calculation - handle both cases
      const mixPalletData = updatedData.filter(
        (item) => item.palletType === "MIXPALLET"
      );

      if (mixPalletData.length > 0) {
        // If there are mixed pallets, calculate their weights
        const directArray = _.map(
          _.groupBy(mixPalletData, "palletName"),
          (items, palletName) => {
            // Sum weights from enabled items only
            return _.sumBy(items, (item) => {
              // Skip disabled duplicates in weight calculation
              if (item.disableContainerType || item.disableDimensions) {
                return 0;
              }

              // For BOX type, use the weight as is (no quantity multiplication)
              if (item.containerType === "BOX") {
                return parseFloat(item.weight || 0);
              }

              // For MASTERCARTON, multiply weight by quantity
              if (item.containerType === "MASTERCARTON") {
                return (
                  parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                );
              }

              // For ITEM, multiply weight by quantity
              if (item.containerType === "ITEM") {
                return (
                  parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                );
              }

              // Default fallback
              return (
                parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
              );
            });
          }
        );
        setTotalWeight(directArray);
      } else {
        // FIXED: Reset totalWeight and clear all manual weight tracking when no items remain
        setTotalWeight([]);
        // Clear manually edited weights for both mix pallets and regular pallets
        setManuallyEditedWeights({});
        setManuallyEditedPalletWeights({});
      }

      setPalletCounter(palletCount);

      // Apply validation to ensure proper disabling of duplicate combinations
      const validatedData = validateDuplicatePalletContainerTypes(updatedData);
      setTableData(validatedData);

      setIsDeleteLoading(false);
      setSelectedShipping(null);
      setIsModalOpen(false);
    }
  };

  const addToExistingPallet = (existingPallet: any, record: any) => {
    const newRow = {
      id: Date.now(),
      palletName: existingPallet.palletName,
      palletType: "MIXPALLET",
      itemName: "",
      itemId: null,
      modelName: "",
      soQuantity: 0,
      containerType: "",
      quantity: 0,
      quantityPerBox: 0,
      totalQuantity: 0,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      remainingItems: 0,
      palletDimensions: existingPallet.palletDimensions, // Use the same dimensions object
      isDimensionsRow: false,
    };

    const filterData = tableData.filter(
      (item) => item.isDimensionsRow === false
    );

    // Add the new row and apply validation
    const newTableData = [...filterData, newRow];
    const validatedData = validateDuplicatePalletContainerTypes(newTableData);

    setTableData(validatedData);
    collapseRowsByPallet(record.palletName);
  };

  const addToCurrentPallet = (record: any) => {
    const newRow = {
      id: Date.now(),
      palletName: record.palletName,
      palletType: "MIXPALLET",
      itemName: "",
      itemId: null,
      modelName: "",
      soQuantity: 0,
      containerType: "",
      quantity: 0,
      quantityPerBox: 0,
      totalQuantity: 0,
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      remainingItems: 0,
      palletDimensions: record.palletDimensions || {
        id: `dim-${Date.now()}`,
        palletLength: 0,
        palletWidth: 0,
        palletHeight: 0,
        palletWeight: 0,
      },
      isDimensionsRow: false,
    };

    const filterData = tableData.filter(
      (item) => item.isDimensionsRow === false
    );

    // Add the new row and apply validation
    const newTableData = [...filterData, newRow];
    const validatedData = validateDuplicatePalletContainerTypes(newTableData);

    setTableData(validatedData);
    collapseRowsByPallet(record.palletName);
  };
  const handleDimensionChange = (
    value: number | string | null,
    field: string,
    record: any
  ) => {
    const filteredDimensions = transformedData.filter(
      (x: any) => x.isDimensionsRow === true
    );

    const filteredDimensionIndex = filteredDimensions.findIndex(
      (x: any) => x.key === record.key
    );

    if (filteredDimensionIndex >= 0 && field === "weight") {
      // FIXED: Initialize sumData based on current filtered dimensions length
      // This ensures we don't carry over old weight values
      const currentDimensionsCount = filteredDimensions.length;
      let sumData = [];

      // If totalWeight array has the correct length, use it; otherwise initialize fresh
      if (totalWeight.length === currentDimensionsCount) {
        sumData = [...totalWeight];
      } else {
        // Initialize with zeros for the correct number of dimensions
        sumData = new Array(currentDimensionsCount).fill(0);
        // Copy any existing values that are still valid
        for (
          let i = 0;
          i < Math.min(totalWeight.length, currentDimensionsCount);
          i++
        ) {
          sumData[i] = totalWeight[i] || 0;
        }
      }

      // Get the current weight value and original weight
      const currentWeight = sumData[filteredDimensionIndex] || 0;
      const originalWeight = originalWeights[record.palletName] || 0;

      // Convert value to a number, defaulting to 0 if invalid
      let newWeight = 0;
      if (value !== null && value !== undefined && value !== "") {
        newWeight =
          typeof value === "string" ? parseFloat(value) : Number(value);
      }

      // For dimension rows, ensure weight is not less than original weight
      if (record.isDimensionsRow) {
        // Ensure weight is not less than original weight and is positive
        newWeight = Math.max(newWeight, originalWeight, 0.01);
      }

      // Update the weight in the array
      sumData[filteredDimensionIndex] = newWeight;
      setTotalWeight(sumData);
    }

    const dimensionField = `pallet${capitalizeFirstLetter(field)}`;
    let updatedData = [];

    // Convert value to number, handling all possible input types
    let validatedValue: number;
    if (value === null || value === undefined || value === "") {
      validatedValue = 0;
    } else if (typeof value === "string") {
      validatedValue = parseFloat(value) || 0;
    } else {
      validatedValue = value;
    }

    // For weight field, ensure the value is not less than the current value
    if (
      field === "weight" &&
      record[field] !== undefined &&
      (record?.rowType !== "main" || record.isDimensionsRow)
    ) {
      setTotalWeightChange(true);
      const currentValue = parseFloat(String(record[field] || 0));

      // For dimension rows, allow user input but ensure it meets minimum requirements
      if (record.isDimensionsRow) {
        // Don't force the value to be >= currentValue for dimensions row
        // Let the validation in the render function handle this
        validatedValue = Math.max(validatedValue, 0.01);
      } else {
        // For non-dimension rows, keep the existing logic
        validatedValue = Math.max(validatedValue, currentValue);
      }
    }

    if (record.isDimensionsRow) {
      if (record.palletType === "MIXPALLET") {
        // Track manually edited weight for mixed pallets ONLY
        if (field === "weight") {
          setManuallyEditedWeights((prev) => ({
            ...prev,
            [record.palletName]: Number(validatedValue || 0),
          }));
        }

        // Update ONLY Mix Pallet items, do not affect regular pallets
        updatedData = tableData.map((item) => {
          if (
            item.palletType === "MIXPALLET" &&
            item.palletName === record.palletName
          ) {
            return {
              ...item,
              palletDimensions: {
                ...item.palletDimensions,
                [dimensionField]: Number(validatedValue || 0),
              },
            };
          }
          return item;
        });
      } else {
        // Handle regular PALLET type weight changes independently
        if (field === "weight") {
          setManuallyEditedPalletWeights((prev) => ({
            ...prev,
            [record.palletName]: Number(validatedValue || 0),
          }));
        }

        // Update ONLY regular Pallet items, do not affect mix pallets
        updatedData = tableData.map((item) =>
          item.id === record.id
            ? {
                ...item,
                [field]: Number(validatedValue || 0),
              }
            : item
        );
      }
    } else {
      // Clear manually edited weight for this pallet when dimensions change
      // Handle Mix Pallets and regular Pallets independently
      if (record.palletType === "MIXPALLET") {
        // For Mix Pallets: Clear manual weight only for non-weight fields or non-dimension weight changes
        // EXCEPT for BOX container type where total weight is independent of quantity/quantityPerBox
        const shouldClearMixPalletWeight =
          (field !== "weight" ||
            (field === "weight" && !record.isDimensionsRow)) &&
          !(
            record.containerType === "BOX" &&
            (field === "quantity" || field === "quantityPerBox")
          );
        if (shouldClearMixPalletWeight) {
          setManuallyEditedWeights((prev) => {
            const updated = { ...prev };
            delete updated[record.palletName];
            return updated;
          });
        }
      } else {
        // For regular Pallets: Clear manual weight only for non-weight fields or non-dimension weight changes
        const shouldClearPalletWeight =
          field !== "weight" || (field === "weight" && !record.isDimensionsRow);

        if (shouldClearPalletWeight) {
          setManuallyEditedPalletWeights((prev) => {
            const updated = { ...prev };
            delete updated[record.palletName];
            return updated;
          });
        }
      }

      const itemTotal = tableData
        .filter(
          (_pallet) =>
            _pallet.itemId === record.itemId && _pallet.id !== record.id
        )
        .reduce(
          (sum, pallet) =>
            sum + (pallet.quantity || 0) * (pallet.quantityPerBox || 1),
          0
        );

      // First determine if we're updating a parent pallet
      const isParentPallet = record.hasClones;

      // If we're updating a parent pallet and it's a dimension field (not quantityPerBox),
      // we need to update all clones too - BUT EXCLUDE WEIGHT FIELD
      const shouldUpdateClones =
        isParentPallet && field !== "quantityPerBox" && field !== "weight";

      // Check if this is an enabled row (first occurrence) and we're updating Length, Width, or Height
      const isDimensionField = ["length", "width", "height"].includes(field);
      const isWeightField = field === "weight";
      const isEnabledRow =
        !record.disableContainerType && !record.disableDimensions;

      // CRITICAL FIX: Only propagate dimension changes if the row hasn't been independently modified
      // This prevents clones that have changed their container type from getting overwritten
      const isRecordClone =
        record.disableContainerType || record.disableDimensions;

      const shouldUpdateDuplicates =
        isDimensionField &&
        isEnabledRow &&
        record.palletName &&
        record.containerType &&
        !record.hasBeenModified &&
        !isRecordClone;

      updatedData = tableData.map((item) => {
        // 1. Update the current record
        if (item.id === record.id) {
          let newTotalQuantity;
          if (field === "quantityPerBox") {
            // Ensure both values are numbers
            const qty = Number(item.quantity || 0);
            const qtyPerBox = Number(validatedValue || 0);
            newTotalQuantity = qty * qtyPerBox;
          } else {
            newTotalQuantity = Number(item.totalQuantity || 0);
          }

          // Calculate remaining items after all allocations
          const totalAllocated = itemTotal + newTotalQuantity;
          const remainingItems = Math.max(
            record.soQuantity - totalAllocated,
            0
          );

          return {
            ...item,
            [field]: Number(validatedValue || 0),
            totalQuantity: Number(newTotalQuantity || 0),
            remainingItems: remainingItems,
          };
        }

        // 2. If the current record is a parent pallet and we're updating a dimension field,
        // update all its clones (all items where parentId = current record's id)
        // FIXED: Exclude weight field from being copied to clones AND only update clones that haven't been modified
        if (
          shouldUpdateClones &&
          item.parentId === record.id &&
          !item.isDimensionsRow
        ) {
          return {
            ...item,
            [field]: Number(validatedValue || 0), // Update the dimension field to match parent (excluding weight)
          };
        }

        // 3. UPDATED: If this is an enabled row updating a dimension field, update all disabled duplicates
        // BUT only if they haven't been independently modified
        if (
          shouldUpdateDuplicates &&
          item.id !== record.id &&
          !item.isDimensionsRow &&
          item.palletName === record.palletName &&
          item.containerType === record.containerType &&
          item.containerTypeName === record.containerTypeName && // ADD THIS LINE
          (item.disableContainerType || item.disableDimensions) &&
          !item.hasBeenModified &&
          !(record.disableContainerType || record.disableDimensions) &&
          !item.isClone
        ) {
          return {
            ...item,
            [field]: Number(validatedValue || 0), // Update the dimension field to match the enabled row
          };
        }

        // 4. For all other pallets with the same itemId, update the remaining items
        // when quantityPerBox is changed
        if (
          field === "quantityPerBox" &&
          item.itemId === record.itemId &&
          item.id !== record.id
        ) {
          // Calculate total quantity for the current record
          const currentRecordQty = record.quantity || 0;
          const currentRecordQtyPerBox = validatedValue || 0;
          const currentRecordTotalQty =
            currentRecordQty * currentRecordQtyPerBox;

          // Calculate total quantity for all pallets with this itemId except the current one
          const otherPalletsTotal = tableData
            .filter((p) => p.itemId === record.itemId && p.id !== record.id)
            .reduce((sum, p) => {
              // If this is the item we're currently processing, use its current values
              if (p.id === item.id) {
                return sum + (p.quantity || 0) * (p.quantityPerBox || 1);
              }
              // Otherwise, use the values from tableData
              return sum + (p.quantity || 0) * (p.quantityPerBox || 1);
            }, 0);

          // Calculate remaining items
          const totalAllocated = otherPalletsTotal + currentRecordTotalQty;
          const remainingItems = Math.max(
            record.soQuantity - totalAllocated,
            0
          );

          return {
            ...item,
            remainingItems: remainingItems,
          };
        }

        return item;
      });
    }

    // Always update the total weight calculation, regardless of field - only for MIXPALLET types
    if (!(record.isDimensionsRow && field === "weight")) {
      // Always update the total weight calculation, regardless of field - only for MIXPALLET types
      const mixPalletData = updatedData.filter(
        (item) => item.palletType === "MIXPALLET"
      );
      if (mixPalletData.length > 0) {
        const directArray = _.map(
          _.groupBy(mixPalletData, "palletName"),
          (items, palletName) => {
            // Sum weights from enabled items only
            return _.sumBy(items, (item) => {
              // Skip disabled duplicates in weight calculation
              if (item.disableContainerType || item.disableDimensions) {
                return 0;
              }

              // For BOX type, use the weight as is (no quantity multiplication)
              if (item.containerType === "BOX") {
                return parseFloat(item.weight || 0);
              }

              // For MASTERCARTON, multiply weight by quantity
              if (item.containerType === "MASTERCARTON") {
                return (
                  parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                );
              }

              // For ITEM, multiply weight by quantity
              if (item.containerType === "ITEM") {
                return (
                  parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
                );
              }

              // Default fallback
              return (
                parseFloat(item.weight || 0) * parseInt(item.quantity || 0)
              );
            });
          }
        );
        setTotalWeight(directArray);
      }
    }

    // Ensure we're setting a new array reference to trigger a re-render
    const newTableData = [...updatedData];
    setTableData(newTableData);
  };

  const handleSaveAndDraft = () => {
    const validatedData = checkForMissingValues(tableData);
    const hasErrors = validatedData.some(
      (pallet: any) =>
        pallet.isContainerTypeError ||
        pallet.isItemError ||
        pallet.isQuantityError
    );

    if (hasErrors) {
      toastText(
        "Pallet item name, container type, and quantity can't be empty. Please add the missing details before saving.",
        "error"
      );
      setTableData(validatedData);
      // transformPalletData(validatedData);
      return;
    }
    const data = transformPalletData(validatedData);
    savePallets(data);
  };

  const transformPalletData = (inputData: any) => {
    // Initialize the output structure
    const output = {
      packagingId: packageId,
      pallets: [],
    };

    // Group items by palletName and palletType
    const groupedPallets = inputData.reduce((acc: any, item: any) => {
      const key = `${item.palletType}_${item.palletName}`;
      if (!acc[key]) {
        acc[key] = {
          items: [],
          palletType: item.palletType,
          palletName: item.palletName,
          // quantityPerBox: item.quantityPerBox,
          isQuantityError: item.isQuantityError || false, // Add error flag
          isContainerTypeError: item.isContainerTypeError || false, // Add error flag
          isItemError: item.isItemError || false, // Add error flag
        };
      }

      // Create item object with only required fields
      const transformedItem: any = {
        itemId: item.itemId,
        quantity: item.quantity,
        containerType: item.containerType,
        containerTypeName: item.containerTypeName,
        quantityPerBox: item.quantityPerBox,
        length: item.length,
        width: item.width,
        height: item.height,
        weight: item.weight,
        isQuantityError: item.isQuantityError || false, // Include error flag
        isContainerTypeError: item.isContainerTypeError || false, // Include error flag
        isItemError: item.isItemError || false, // Include error flag
      };

      // For PALLET type, add remainingItems if present
      if (item.palletType === "PALLET" && "remainingItems" in item) {
        transformedItem.remainingItems =
          item.remainingItems > 0 ? item.remainingItems : 0;
      }

      if (
        item.palletType === "MIXPALLET" &&
        "remainingItems" in item &&
        item.remainingItems !== null
      ) {
        transformedItem.remainingItems =
          item.remainingItems > 0 ? item.remainingItems : 0;
      }

      // For PALLET type, include dimensions directly in the pallet
      if (item.palletDimensions) {
        acc[key].palletDimensions = {
          length:
            item.palletDimensions.palletLength ||
            item.palletDimensions.length ||
            0,
          width:
            item.palletDimensions.palletWidth ||
            item.palletDimensions.width ||
            0,
          height:
            item.palletDimensions.palletHeight ||
            item.palletDimensions.height ||
            0,
          weight:
            item.palletDimensions.palletWeight ||
            item.palletDimensions.weight ||
            0,
        };
      }

      // Add the transformed item
      if (item.palletType === "PALLET") {
        // For PALLET type, add items directly to the pallet object
        Object.assign(acc[key], transformedItem);
      } else {
        // For MIXPALLET type, add items to the items array
        acc[key].items.push(transformedItem);
      }

      return acc;
    }, {});

    // Convert grouped pallets to array format
    output.pallets = Object.values(groupedPallets);

    return output;
  };

  // Cancel operation
  const handleCancel = () => {
    setIsDeleteLoading(false);
    setSelectedShipping(null);
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setIsDeleteLoading(false);
    setSelectedShipping(null);
    setIsModalOpen(false);
  };

  const handleOrderClick = () => {
    setIsOrderStatusModalOpen(true);
  };

  // Handler for closing the order status modal
  const handleOrderStatusModalClose = () => {
    setIsOrderStatusModalOpen(false);
  };

  const getLastPalletByItem = (data: any[], itemId: string) => {
    const pallets = data
      .filter((row) => row.itemId === itemId && row.palletType === "PALLET")
      .sort((a, b) => {
        const aNum = parseInt(a.palletName.split(" ")[1]);
        const bNum = parseInt(b.palletName.split(" ")[1]);
        return bNum - aNum;
      });
    return pallets[0];
  };

  const collapseRowsByPallet = (palletName: string) => {
    setExpandedRowKeys((prevKeys: any) =>
      prevKeys.filter((key: any) => {
        const row = tableData.find((item) => item.id === key);
        return row?.palletName !== palletName;
      })
    );
  };

  const collapseAllRows = () => {
    setExpandedRowKeys([]);
  };

  const getLastMixPalletRowByPallet = (palletName: string) => {
    // Filter rows belonging to the specified Mixed Pallet
    const mixedPalletRows = tableData.filter(
      (row) => row.palletName === palletName
    );

    // Return the last row, or undefined if no rows are found
    return mixedPalletRows[mixedPalletRows.length - 1];
  };

  const addNewItemWithSameBox = (record) => {
    const newId = Date.now();

    // Handle case where we're cloning a clone - we need to point to the original parent
    // This ensures a clear parent-children hierarchy rather than a chain
    const parentId = record.isClone ? record.parentId : record.id;

    // Create a new row with the same mixed pallet name and same item
    const newRow = {
      id: newId,
      palletName: record.palletName, // Same mixed pallet name
      palletType: "MIXPALLET",
      itemName: "", // Same item
      itemId: null, // Same item ID
      modelName: record.modelName,
      soQuantity: record.soQuantity,
      containerType: "BOX", // Same as the original
      containerTypeName: record.containerTypeName, // Same box name as the original
      quantity: 0, // Reset quantity
      quantityPerBox: record.quantityPerBox, // Keep the same quantities per box
      totalQuantity: 0, // Reset total quantity
      length: record.length, // Keep the same dimensions
      width: record.width,
      height: record.height,
      weight: 0,
      remainingItems: record.remainingItems,
      palletDimensions: { ...record.palletDimensions, palletWeight: 0 }, // Use the same pallet dimensions object
      isDimensionsRow: false,
      disableContainerType: true, // Flag to disable container type changes
      disableDimensions: true, // Flag to disable dimensions
      parentId: parentId, // Add reference to the TRUE parent pallet
      isClone: true, // Flag to identify as a clone
      hasBeenModified: false,
    };

    // Filter out dimension rows first
    const filteredData = tableData.filter(
      (item) => item.isDimensionsRow === false
    );

    // Update the parent record to also disable container type
    const updatedData = filteredData.map((item) => {
      if (item.id === parentId) {
        return {
          ...item,
          disableContainerType: true,
          // We don't set disableDimensions for parent so it can still be edited
          hasClones: true, // Flag indicating this pallet has clones
        };
      }
      return item;
    });

    // Add the new row and apply validation
    const newTableData = [...updatedData, newRow];
    const validatedData = validateDuplicatePalletContainerTypes(newTableData);

    setTableData(validatedData);
    collapseRowsByPallet(record.palletName);
  };

  const getExpandedRowRender = (record: any) => {
    const existingPallets = tableData
      .filter(
        (item) =>
          item.palletType === "MIXPALLET" &&
          item.palletName !== record.palletName
      )
      .filter(
        (item, index, self) =>
          self.findIndex((i) => i.palletName === item.palletName) === index
      );

    const isLastMixPalletForItem =
      getLastMixPalletRowByPallet(record.palletName)?.id === record.id;

    return (
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{
            padding: 10,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "4rem",
            border: "1px solid grey",
            borderRadius: "12px",
          }}
        >
          <p>
            Remaining Items:{" "}
            {record.remainingItems < 0 ? 0 : record.remainingItems}
          </p>
          {record.palletType === "PALLET" &&
            record.quantity > 0 &&
            record.quantity < record.soQuantity && (
              <Button
                type="primary"
                onClick={() => createNewPallet(record)}
                style={{ marginRight: 8 }}
                disabled={!record.remainingItems}
              >
                Create a new Pallet
              </Button>
            )}

          {isLastMixPalletForItem && record?.palletType === "MIXPALLET" && (
            <Button
              type="primary"
              onClick={() => {
                addToCurrentPallet(record);
              }}
              style={{ marginRight: 8 }}
            >
              Add Item to Current Pallet
            </Button>
          )}

          {record?.palletType === "MIXPALLET" &&
            record?.containerType === "BOX" && (
              <Button
                type="primary"
                onClick={() => addNewItemWithSameBox(record)}
                style={{ marginRight: 8 }}
              >
                Add Items to the same Box
              </Button>
            )}

          {record?.palletType === "MIXPALLET" &&
            existingPallets.length > 0 &&
            isLastMixPalletForItem && (
              <Select
                placeholder="Add to existing pallet"
                style={{ width: 200 }}
                onChange={(value) => {
                  const selectedPallet = existingPallets.find(
                    (p) => p.id === value
                  );
                  if (selectedPallet) {
                    addToExistingPallet(selectedPallet, record);
                  }
                }}
                disabled={!record.remainingItems}
              >
                {existingPallets.map((pallet) => (
                  <Select.Option key={pallet.id} value={pallet.id}>
                    {pallet.palletName}
                  </Select.Option>
                ))}
              </Select>
            )}
        </div>
      </div>
    );
  };

  const handleExpand = (expanded: boolean, record: any) => {
    if (expanded) {
      if (record?.palletType === "MIXPALLET") {
        setExpandedRowKeys([record.id]);
      } else {
        setExpandedRowKeys((prevKeys: any) => [...prevKeys, record.id]);
      }
      // setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys((prevKeys: any) =>
        prevKeys.filter((key: any) => key !== record.id)
      );
    }
  };

  //  API Calls

  const fetchItems = async (packageId: string) => {
    try {
      setPalletsLoading(true);
      const response = await getApi("/shipping/item-options", {
        packageId,
      });

      setItems(response.data.data);
      await fetchPallets(packageId, response.data.data);
    } catch (error) {
      console.error("Failed to fetch items:", error);
    } finally {
      setPalletsLoading(false);
    }
  };

  const fetchPallets = async (packageId: string, _items: any) => {
    try {
      setPalletsLoading(true);
      const response = await getApi("/pallets", {
        packageId,
      });
      if (response.data.data && response.data.data.pallets.length > 0) {
        const validItemIds = new Set(_items.map((item: any) => item.id));
        const _data = response.data.data.pallets.map((pallet: any) => {
          const soQty = _items.find((_item: any) => _item.id === pallet.itemId);
          const isStaleItem =
            !pallet.isDimensionsRow &&
            pallet.itemId !== null &&
            pallet.itemId !== undefined &&
            !validItemIds.has(pallet.itemId);

          return {
            ...pallet,
            ...(isStaleItem
              ? {
                  itemId: null,
                  itemName: "",
                  modelName: "",
                  soQuantity: 0,
                  remainingItems: 0,
                  isItemError: true,
                }
              : {}),
            soQuantity: soQty ? soQty.quantity : 0,
          };
        });

        // Validate and disable duplicate pallet and container type combinations
        const validatedData = validateDuplicatePalletContainerTypes(_data);

        // Set the pallet counter based on the number of regular pallets
        setPalletCounter(
          validatedData.filter(
            (item: any) =>
              item.palletType === "PALLET" && item.isDimensionsRow === false
          ).length + 1
        );

        // No longer need to set mixedPalletCounter since we removed it

        setTableData(validatedData);
      }
    } catch (error) {
      console.error("Failed to fetch items:", error);
    } finally {
      setPalletsLoading(false);
    }
  };

  // Function to validate and disable duplicate pallet and container type combinations
  const validateDuplicatePalletContainerTypes = (data: any[]) => {
    // Group data by pallet name and container type name, but ONLY for BOX container types
    const groupedData = data.reduce((acc: any, item: any) => {
      // Only apply disable logic for BOX container types with containerTypeName
      if (
        !item.palletName ||
        item.containerType !== "BOX" ||
        !item.containerTypeName
      )
        return acc;

      const key = `${item.palletName}_${item.containerTypeName}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {});

    // Process each group and disable duplicates
    const processedData = data.map((item: any) => {
      // If item doesn't have pallet name, or is not BOX type, or no containerTypeName, keep it enabled
      if (
        !item.palletName ||
        item.containerType !== "BOX" ||
        !item.containerTypeName
      ) {
        return {
          ...item,
          disableContainerType: false,
          // disableDimensions: false,
        };
      }

      const key = `${item.palletName}_${item.containerTypeName}`;
      const group = groupedData[key];

      if (group && group.length > 1) {
        // Find the index of this item in the group
        const sortedGroup = group.sort((a: any, b: any) => {
          // Parent (not a clone) comes first
          if (!a.isClone && b.isClone) return -1;
          if (a.isClone && !b.isClone) return 1;
          // If both are clones or both are parents, maintain original order by id
          return a.id - b.id;
        });
        const itemIndex = sortedGroup.findIndex(
          (groupItem: any) => groupItem.id === item.id
        );

        if (itemIndex === 0) {
          // First occurrence - keep enabled
          return {
            ...item,
            disableContainerType: false,
            // disableDimensions: false,
          };
        } else {
          // Subsequent occurrences - disable and set weight to 0
          // const shouldDisable =
          //   item.isClone &&
          //   !item.hasBeenModified &&
          //   item.containerTypeName === sortedGroup[0].containerTypeName;
          return {
            ...item,
            disableContainerType: true,
            disableDimensions: true,
            // weight: 0,
          };
        }
      }

      // No duplicates - keep enabled
      return {
        ...item,
        disableContainerType: false,
        // disableDimensions: false,
      };
    });

    return processedData;
  };

  const savePallets = async (data: any) => {
    // Set loader state to true
    setIsSaveAndDraftLoading(true);

    try {
      const response = await postApi("/pallets", data);
      const message = response?.data?.message || "Pallet saved successfully";
      toastText(message, "success");
      handleShippingCancel();
    } catch (err) {
      toastText("Something went wrong in saving pallets", "error");
    } finally {
      // Stop loader after API call finishes
      setIsSaveAndDraftLoading(false);
    }
  };

  const completePackingList = async (data: any) => {
    try {
      setIsCreatePackingLoading(true);
      // const data = { packagingId: packageId };
      const response = await putApi("/packing-list/status", data);
      const message =
        response?.data?.message || "Packing Slip created successfully";
      toastText(message, "success");
      handleShippingCancel();
    } catch (err) {
      toastText("Something went wrong in creating packing slip", "error");
    } finally {
      setIsCreatePackingLoading(false);
    }
  };

  const handlePackingList = () => {
    const validatedData = checkForMissingValues(tableData);
    const hasErrors = validatedData.some(
      (pallet: any) =>
        pallet.isContainerTypeError ||
        pallet.isItemError ||
        pallet.isQuantityError
    );

    if (hasErrors) {
      toastText(
        "Pallet item name, container type, and quantity can't be empty. Please add the missing details before creating packing slip.",
        "error"
      );
      setTableData(validatedData);
      transformPalletData(validatedData);
      return;
    }
    setTableData(validatedData);
    return true;
  };

  const columns = [
    {
      title: "Pallet",
      dataIndex: "palletName",
      key: "palletName",
      width: "140px",
      render: (text: string, record: any) =>
        record.isDimensionsRow ? null : text,
    },
    {
      title: "Item",
      dataIndex: "itemName",
      key: "itemName",
      width: "200px",
      render: (_: any, record: any) => {
        if (record.isDimensionsRow) return null;

        // Error flags
        const isItemError = record.isItemError;
        return (
          <Form.Item
            validateStatus={isItemError ? "error" : ""}
            style={{ width: "100%" }}
          >
            <Select
              value={record.itemId || undefined}
              onChange={(value) => handleItemChange(value, record)}
              placeholder="Select item"
            >
              {items?.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      },
    },
    {
      title: "SO Qty",
      dataIndex: "soQuantity",
      key: "soQuantity",
      width: "110px",
      render: (text: string, record: any) =>
        record.isDimensionsRow ? null : text,
    },
    {
      title: "Model",
      dataIndex: "modelName",
      key: "modelName",
      width: "140px",
      render: (text: string, record: any) =>
        record.isDimensionsRow ? null : text,
    },
    {
      title: "Box/Item/MC",
      dataIndex: "containerType",
      key: "containerType",
      width: "180px",
      render: (text: any, record: any) => {
        if (record.isDimensionsRow) return null;

        const isContainerTypeError = record.isContainerTypeError;

        // Extract the current box number from containerTypeName (e.g., Box6 -> 6)
        const currentBoxNumber =
          record.containerType === "BOX" && record.containerTypeName
            ? parseInt(record.containerTypeName.replace("Box ", ""), 10)
            : 0;

        // Determine the total number of boxes to render (e.g., up to Box6)
        const totalBoxes = Math.max(customBoxCounter, currentBoxNumber || 0);
        const usedBoxes = getUsedBoxesForPallet(record.palletName);

        return (
          <div className="flex items-center gap-2">
            <Form.Item
              validateStatus={isContainerTypeError ? "error" : ""}
              style={{ width: "100%" }}
            >
              <Select
                value={
                  record.containerType === "BOX"
                    ? record.containerTypeName
                    : text || undefined
                }
                onChange={(value) => handleContainerTypeChange(value, record)}
                placeholder="Select type"
                disabled={
                  !record.itemName ||
                  (record.disableContainerType &&
                    record.containerType === "BOX" &&
                    record.containerTypeName === text)
                } // Add this disabled check
                dropdownRender={(menu) => (
                  <div>
                    {menu}
                    {record?.palletType === "MIXPALLET" &&
                      !record.disableContainerType && (
                        <div style={{ padding: "10px" }}>
                          <Button
                            onClick={() => {
                              setCustomBoxCounter((prev) => prev + 1);
                            }}
                            size="small"
                            type="default"
                            className="w-full"
                          >
                            + Add New Box
                          </Button>
                        </div>
                      )}
                  </div>
                )}
              >
                {record?.palletType !== "MIXPALLET" ? (
                  <>
                    <Select.Option value="ITEM">Item</Select.Option>
                    <Select.Option value="MASTERCARTON">
                      Master Carton
                    </Select.Option>
                  </>
                ) : (
                  <>
                    <Select.Option value="ITEM">Item</Select.Option>
                    <Select.Option value="MASTERCARTON">
                      Master Carton
                    </Select.Option>
                    {Array.from({ length: totalBoxes }).map((_, index) => {
                      const boxName = `Box ${index + 1}`;
                      const isBoxUsed = usedBoxes.includes(boxName);
                      const isCurrentBox = record.containerTypeName === boxName;

                      return (
                        <Select.Option
                          key={boxName}
                          value={boxName}
                          disabled={isBoxUsed && !isCurrentBox} // Disable if used by another row
                          style={{
                            color:
                              isBoxUsed && !isCurrentBox ? "#ccc" : "inherit",
                            backgroundColor:
                              isBoxUsed && !isCurrentBox
                                ? "#f5f5f5"
                                : "inherit",
                          }}
                        >
                          {boxName} {isBoxUsed && !isCurrentBox ? "(Used)" : ""}
                        </Select.Option>
                      );
                    })}
                  </>
                )}
              </Select>
            </Form.Item>
          </div>
        );
      },
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: "120px",
      render: (text: any, record: any) => {
        if (record.isDimensionsRow) return null;

        return (
          <Form.Item style={{ margin: 0 }}>
            <InputNumber
              value={text === 0 ? 0 : text}
              // max={999999999}
              maxLength={9}
              onBlur={(e) => {
                let value = Number(e.target.value);

                value = Math.round(value);

                value = value < 0 ? 0 : value;

                handleQuantityChange(value, record);
              }}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  let value = Number(e.target.value);

                  value = Math.round(value);

                  value = value < 0 ? 0 : value;

                  handleQuantityChange(value, record);
                }
              }}
              style={{ width: "100%" }}
              disabled={!record.containerType}
            />
          </Form.Item>
        );
      },
    },
    {
      title: "Qty per Box",
      dataIndex: "quantityPerBox",
      key: "quantityPerBox",
      width: "120px",
      render: (text: any, record: any) => {
        if (record.isDimensionsRow) {
          return {
            children: "Pallet Dimensions",
            props: { colSpan: 2 },
          };
        }

        return (record.containerType === "BOX" || record.isEditableRow) &&
          !record.isDimensionsRow ? (
          <InputNumber
            value={text || 0}
            style={{ width: "100%" }}
            maxLength={9}
            onBlur={(e: any) => {
              let value = Number(e.target.value);
              value = Math.round(value);
              value = value < 0 ? 0 : value;
              handleDimensionChange(value, "quantityPerBox", record);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                let value = Number(e.target.value);
                value = Math.round(value);
                value = value < 0 ? 0 : value;
                handleDimensionChange(value, "quantityPerBox", record);
              }
            }}
            min={0}
            // We don't disable this field for cloned pallets (disableDimensions flag is not checked)
          />
        ) : (
          text
        );
      },
    },
    {
      title: (
        <Tooltip title="Quantity * Qty per Box" destroyTooltipOnHide>
          <span>Total Qty</span>
        </Tooltip>
      ),
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      width: "120px",
      render: (text: any, record: any) => {
        if (record.isDimensionsRow) {
          return { props: { colSpan: 0 } };
        }
        return text;
      },
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
      width: "120px",
      render: (text: any, record: any) =>
        record.containerType === "BOX" || record.isEditableRow ? (
          <InputNumber
            value={text || 0}
            precision={2}
            step={0.01}
            maxLength={9}
            onBlur={(e: any) => {
              const newValue = (e.target.value || "")
                .toString()
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1")
                .replace(/^(\d*\.\d{2}).*/, "$1");

              handleDimensionChange(newValue, "length", record);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                const newValue = (e.target.value || "")
                  .toString()
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*?)\..*/g, "$1")
                  .replace(/^(\d*\.\d{2}).*/, "$1");

                handleDimensionChange(newValue, "length", record);
              }
            }}
            min={0}
            disabled={record.disableDimensions}
          />
        ) : (
          text
        ),
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      width: "120px",
      render: (text: any, record: any) =>
        record.containerType === "BOX" || record.isEditableRow ? (
          <InputNumber
            value={text || 0}
            precision={2}
            step={0.01}
            maxLength={9}
            onBlur={(e: any) => {
              const newValue = (e.target.value || "")
                .toString()
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1")
                .replace(/^(\d*\.\d{2}).*/, "$1");

              handleDimensionChange(newValue, "width", record);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                const newValue = (e.target.value || "")
                  .toString()
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*?)\..*/g, "$1")
                  .replace(/^(\d*\.\d{2}).*/, "$1");

                handleDimensionChange(newValue, "width", record);
              }
            }}
            min={0}
            disabled={record.disableDimensions}
          />
        ) : (
          text
        ),
    },

    // 4. Height Column
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
      width: "120px",
      render: (text: any, record: any) =>
        record.containerType === "BOX" || record.isEditableRow ? (
          <InputNumber
            value={text || 0}
            precision={2}
            step={0.01}
            maxLength={9}
            onBlur={(e: any) => {
              const sanitizedValue = (e.target.value || "")
                .toString()
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1")
                .replace(/^(\d*\.\d{2}).*/, "$1");

              handleDimensionChange(sanitizedValue, "height", record);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                const sanitizedValue = (e.target.value || "")
                  .toString()
                  .replace(/[^0-9.]/g, "")
                  .replace(/(\..*?)\..*/g, "$1")
                  .replace(/^(\d*\.\d{2}).*/, "$1");

                handleDimensionChange(sanitizedValue, "height", record);
              }
            }}
            min={0}
            disabled={record.disableDimensions}
          />
        ) : (
          text
        ),
    },

    // 5. Weight Column
    {
      title: "Weight",
      dataIndex: "weight",
      key: "weight",
      width: "120px",
      render: (text: any, record: any) => {
        // Check if this row is disabled due to being a duplicate of the same pallet and Box/Item/MC
        const isDisabledDuplicate =
          record.disableContainerType || record.disableDimensions;

        // If this is a disabled duplicate row, show 0 and disable the field
        if (
          isDisabledDuplicate &&
          record.containerType == "BOX" &&
          record.containerTypeName === text
        ) {
          return "0.00";
        }
        const handleWeightChange = (inputValue: string, record: any) => {
          // Get the current value and ensure it's a number
          const currentWeight = parseFloat(text || 0);
          const TotalSum = _.sum(record.totalWeightTransform) || 0;

          // Parse and sanitize the input value
          const sanitizedStr = inputValue
            .replace(/[^0-9.]/g, "")
            .replace(/(\..*?)\..*/g, "$1")
            .replace(/^(\d*\.\d{2}).*/, "$1");

          // Convert to number
          let numericValue = parseFloat(sanitizedStr) || 0;

          // If the value is negative, use its absolute value
          if (numericValue < 0) {
            numericValue = Math.abs(numericValue);
          }

          // Apply validation rules based on row type
          if (record.isDimensionsRow) {
            // For dimension rows, ensure weight is at least 0.01
            numericValue = Math.max(numericValue, 0.01);
            // But allow it to be less than TotalSum if needed for corrections
            numericValue = Math.max(numericValue, TotalSum);
          } else if (record.rowType !== "main" && numericValue < TotalSum) {
            // For non-main rows, don't allow weight less than total sum
            numericValue = Math.max(numericValue, TotalSum);
          }

          // Convert to number explicitly to ensure type consistency
          const finalValue = Number(numericValue.toFixed(2));

          // Only update if value actually changed
          if (Math.abs(finalValue - currentWeight) > 0.001) {
            handleDimensionChange(finalValue, "weight", record);
          }
        };
        return (record.containerType === "BOX" || record.isEditableRow) &&
          !record.isDimensionsRow ? (
          <InputNumber
            value={text || 0}
            min={0}
            precision={2}
            step={0.01}
            maxLength={9}
            onBlur={(e: any) => {
              // Get the current value and ensure it's a number
              const currentWeight = parseFloat(text || 0);
              const TotalSum = _.sum(record.totalWeightTransform);

              // Parse and sanitize the input value
              const inputStr = (e.target.value || "").toString();
              const sanitizedStr = inputStr
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1")
                .replace(/^(\d*\.\d{2}).*/, "$1");

              // Convert to number
              let numericValue = parseFloat(sanitizedStr);

              // If the value is negative, use its absolute value
              if (numericValue < 0) {
                numericValue = Math.abs(numericValue);
              }

              // For dimension rows, ensure weight is always positive and not less than actual calculated weight
              if (record.isDimensionsRow) {
                // Ensure the value is at least 0.01 (positive)
                numericValue = Math.max(numericValue, 0.01);

                // Ensure the new value is not less than the actual calculated weight from items
                numericValue = Math.max(numericValue, TotalSum);
              }
              // For non-dimension rows with rowType !== "main"
              else if (numericValue < TotalSum && record.rowType !== "main") {
                numericValue = currentWeight;
              }

              // Pass the validated value to the handler
              // Convert to number explicitly to ensure type consistency
              const finalValue = Number(numericValue);
              if (finalValue != currentWeight) {
                if (record.isDimensionsRow) {
                  // Always allow updates for dimensions row as long as it meets the minimum requirement
                  handleDimensionChange(finalValue, "weight", record);
                } else if (
                  numericValue > TotalSum &&
                  record.rowType !== "main"
                ) {
                  handleDimensionChange(finalValue, "weight", record);
                } else {
                  handleDimensionChange(finalValue, "weight", record);
                }
              }
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                handleWeightChange(e.target.value || "", record);
              }
            }}
            disabled={record.disableDimensions || isDisabledDuplicate}
          />
        ) : record.isDimensionsRow ? (
          ""
        ) : (
          text
        );
      },
    },
    {
      title: (
        <Tooltip
          title="Total weight of all items. Minimum value is based on actual calculated weight from items."
          destroyTooltipOnHide
        >
          <span>Total Weight</span>
        </Tooltip>
      ),
      dataIndex: "totalWeight",
      key: "totalWeight",
      width: "120px",
      // FIXED render logic for Total Weight column
      render: (text: any, record: any) => {
        // Check if this row is disabled due to being a duplicate of the same pallet and Box/Item/MC
        const isDisabledDuplicate =
          record.disableContainerType || record.disableDimensions;

        // If this is a disabled duplicate row, show 0 for total weight
        if (isDisabledDuplicate && record.containerType == "BOX") {
          return "0.00";
        }
        const actualTotalWeight = _.sum(record.totalWeightTransform) || 0;

        // For enabled rows with the same box, show the weight value as total weight
        if (!isDisabledDuplicate && !record.isDimensionsRow) {
          if (
            record.quantity === 0 ||
            record.quantity === null ||
            record.quantity === undefined
          ) {
            return "0.00";
          } else if (record.containerType === "MASTERCARTON") {
            const totalWeight = Number(record.weight) * Number(record.quantity);
            return totalWeight.toFixed(2);
          } else if (record.containerType === "BOX") {
            const totalWeight = Number(record.weight);
            return totalWeight.toFixed(2);
          } else if (record.containerType === "ITEM") {
            const totalWeight = Number(record.weight) * Number(record.quantity);
            return totalWeight.toFixed(2);
          } else {
            const totalWeight = Number(record.weight) * Number(record.quantity);
            return totalWeight.toFixed(2);
          }
        }
        let displayValue;
        if (record.isDimensionsRow) {
          // ANTI-FLICKER FIX: Priority system to prevent flickering
          const filteredDimensions = transformedData.filter(
            (x: any) => x.isDimensionsRow === true
          );
          const filteredDimensionIndex = filteredDimensions.findIndex(
            (x: any) => x.key === record.key
          );

          // Priority 1: Check manually edited weights first (highest priority)
          let hasManualWeight = false;
          if (
            record.palletType === "MIXPALLET" &&
            manuallyEditedWeights[record.palletName] !== undefined
          ) {
            displayValue = manuallyEditedWeights[record.palletName];
            hasManualWeight = true;
          } else if (
            record.palletType === "PALLET" &&
            manuallyEditedPalletWeights[record.palletName] !== undefined
          ) {
            displayValue = manuallyEditedPalletWeights[record.palletName];
            hasManualWeight = true;
          }

          // Priority 2: If no manual weight, check totalWeight array
          if (!hasManualWeight) {
            const currentWeightFromArray = totalWeight[filteredDimensionIndex];
            if (
              currentWeightFromArray !== undefined &&
              currentWeightFromArray !== null &&
              currentWeightFromArray > 0
            ) {
              displayValue = currentWeightFromArray;
              hasManualWeight = true; // Treat array value as manual to prevent overwrite
            }
          }

          // Priority 3: Only use calculated/fallback values if no manual weight exists
          if (!hasManualWeight) {
            if (
              record.totalWeight !== undefined &&
              record.totalWeight !== null &&
              record.totalWeight > 0
            ) {
              displayValue = record.totalWeight;
            } else {
              displayValue = Math.max(0.01, actualTotalWeight);
            }
          }

          // Ensure minimum value requirement
          displayValue = Math.max(displayValue, actualTotalWeight, 0.01);
        } else {
          // For regular rows, calculate based on container type and quantity
          if (
            record.quantity === 0 ||
            record.quantity === null ||
            record.quantity === undefined
          ) {
            displayValue = 0;
          } else if (record.containerType === "BOX") {
            displayValue = Number(record.weight || 0);
          } else if (record.containerType === "MASTERCARTON") {
            displayValue =
              Number(record.weight || 0) * Number(record.quantity || 0);
          } else if (record.containerType === "ITEM") {
            displayValue =
              Number(record.weight || 0) * Number(record.quantity || 0);
          } else {
            displayValue =
              Number(record.weight || 0) * Number(record.quantity || 0);
          }
        }

        // Check if the weight field has a valid input value
        const hasValidWeight =
          record.weight !== null &&
          record.weight !== undefined &&
          record.weight !== "" &&
          !isNaN(parseFloat(record.weight)) &&
          parseFloat(record.weight) > 0;
        const handleTotalWeightChange = (inputValue: string, record: any) => {
          const currentWeight = displayValue || 0;
          const calculatedMinimum = Math.max(0.01, actualTotalWeight);

          const sanitizedStr = inputValue
            .replace(/[^0-9.]/g, "")
            .replace(/(\..*?)\..*/g, "$1")
            .replace(/^(\d*\.\d{2}).*/, "$1");

          let numericValue = parseFloat(sanitizedStr) || 0;

          if (numericValue < 0) {
            numericValue = Math.abs(numericValue);
          }

          if (record.isDimensionsRow) {
            numericValue = Math.max(numericValue, calculatedMinimum);
          }

          const finalValue = Number(numericValue.toFixed(2));

          // ANTI-FLICKER: Always update to ensure state consistency
          if (
            Math.abs(finalValue - currentWeight) > 0.001 ||
            finalValue !== currentWeight
          ) {
            handleDimensionChange(finalValue, "weight", record);
          }
        };
        return record.isDimensionsRow ? (
          <InputNumber
            value={displayValue || 0}
            min={Math.max(0.01, actualTotalWeight)}
            precision={2}
            step={0.01}
            maxLength={9}
            onBlur={(e: any) => {
              handleTotalWeightChange(e.target.value || "", record);
            }}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                handleTotalWeightChange(e.target.value || "", record);
              }
            }}
            disabled={
              record.disableDimensions || !hasValidWeight || isDisabledDuplicate
            }
          />
        ) : (
          (() => {
            return text == undefined ? text : text.toFixed(2);
          })()
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: "100px",

      render: (_: any, record: any) => {
        if (record.isDimensionsRow) return null;
        return (
          <div
            onClick={() => {
              setSelectedShipping(record);
              setIsModalOpen(true);
              // deleteHandler();
            }}
            style={{ cursor: "pointer" }}
          >
            <DeleteActionSvg />
          </div>
        );
      },
    },
  ];

  const getItemWiseData = (itemArray: any, palletArray: any) => {
    return itemArray.map((item: any) => {
      // Get all pallets for this itemId
      const palletsForItem = palletArray.filter(
        (pallet: any) => pallet.itemId === item.id
      );

      // Calculate total packed quantity from pallets
      const totalPalletQuantity = palletsForItem.reduce(
        (sum: number, pallet: any) => sum + pallet.totalQuantity,
        0
      );

      // Determine the packing status
      const status =
        totalPalletQuantity > item.quantity
          ? "OVER_PACKED"
          : totalPalletQuantity < item.quantity
          ? "UNDER_PACKED"
          : "CORRECTLY_PACKED";

      const palletNames = palletsForItem
        .map((pallet: any) => {
          const palletName = pallet.palletName.toLowerCase();
          if (palletName.includes("mixed")) {
            return "MP" + palletName.match(/\d+/)?.[0] || "";
          } else if (palletName.includes("pallet")) {
            return "P" + palletName.match(/\d+/)?.[0] || "";
          } else {
            return palletName;
          }
        })
        .join(", ");

      // Return the item-wise data
      return {
        itemId: item.id,
        itemName: item.name,
        totalQuantity: item.quantity,
        totalPalletQuantity,
        status,
        palletNames,
      };
    });
  };

  const handleCreatePackingList = async () => {
    const isValid = handlePackingList();

    if (!isValid) return;

    const allCorrectlyPacked = finalItemStatus.every(
      (item: any) => item.status === "CORRECTLY_PACKED"
    );

    if (allCorrectlyPacked) {
      const data = transformPalletData(tableData);
      await completePackingList(data);
      navigate("/packing-list");
      return;
    }

    const discrepanciesList = finalItemStatus
      .filter((item: any) => item.status !== "CORRECTLY_PACKED")
      .map((item: any) => {
        const packed = item.totalPalletQuantity;
        const expected = item.totalQuantity;
        const status = item.status
          .replace(/_/g, "-") // Replace underscores with hyphens
          .toLowerCase()
          .replace(/\b\w/g, (char: any) => char.toUpperCase()); // Capitalize the first letter of each word

        return {
          itemName: item.itemName,
          packed,
          expected,
          status,
        };
      });

    setDiscrepancies(discrepanciesList);
    setIsDiscrepancyModalOpen(true);
  };

  const handleConfirmDiscrepancy = async () => {
    const data = transformPalletData(tableData);
    await completePackingList(data);
    // fetchAllCompletedSalesOrder();
    setIsDiscrepancyModalOpen(false);
    navigate("/packing-list");
  };

  const handleCancelDiscrepancy = () => {
    setIsDiscrepancyModalOpen(false);
  };

  useEffect(() => {
    if (packageId && isOpen) {
      fetchItems(packageId);
      // fetchPallets(packageId);
    }
  }, [packageId, isOpen]);

  useEffect(() => {
    if (tableData) {
      const groupedData: any = [];

      // Group pallets by palletName
      const groupedPallets = tableData.reduce((acc, record) => {
        if (!acc[record.palletName]) {
          acc[record.palletName] = [];
        }
        acc[record.palletName].push(record);
        return acc;
      }, {});
      const totalWeightTransform: any = {};
      // Process grouped pallets
      Object.entries(groupedPallets).forEach(
        ([palletName, pallets]: any, index: number) => {
          // Sort pallets by id (or any other criteria if needed)
          pallets.sort((a: any, b: any) => a.id - b.id);
          let sum: any = 0;
          let totalsum: any = 0;
          let qty: any = 0;
          const palletWeightTransform: any = []; // Track weights for this specific pallet

          // Add each pallet's main row
          pallets.forEach((pallet: any, palletIndex: number) => {
            const mainRow = {
              ...pallet,
              key: pallet.id,
              rowType: "main",
            };

            // Check if palletType is MIXPALLET and set isEditableRow based on containerType
            if (pallet.palletType === "MIXPALLET") {
              mainRow.isEditableRow = pallet.containerType === "BOX";
              let rowWeight = 0;

              // Updated logic: For master carton, total weight = quantity * weight
              if (pallet.containerType === "MASTERCARTON") {
                rowWeight = Number(pallet.weight) * Number(pallet.quantity);
              } else if (pallet.containerType === "BOX") {
                // For BOX type, use weight as is (no quantity multiplication)
                rowWeight = Number(pallet.weight);
              } else if (pallet.containerType === "ITEM") {
                // For ITEM type, multiply weight by quantity
                rowWeight = Number(pallet.weight) * Number(pallet.quantity);
              } else {
                // Default fallback
                rowWeight = Number(pallet.weight) * Number(pallet.quantity);
              }

              // Add to pallet-specific weight transform array
              palletWeightTransform.push(rowWeight);

              sum += rowWeight || 0;
              qty += Number(pallet.totalQuantity);

              if (pallet.totalQuantity === 0 || pallet.weight === 0) {
                mainRow.totalWeight = 0;
              } else {
                mainRow.totalWeight = rowWeight;
              }
              totalsum += Number(mainRow.totalWeight);
            }

            groupedData.push(mainRow);
          });

          // Store the weight transform array for this pallet
          totalWeightTransform[index] = palletWeightTransform;

          // Add a single dimension row for the pallet group
          const dimensions = pallets[0]?.palletDimensions || {};

          let sumFinal = 0;
          // let totalQty = 0;
          if (pallets[0].palletType === "MIXPALLET") {
            // Check if this Mix Pallet has a manually edited weight (independent from regular pallets)
            const manualWeight = manuallyEditedWeights[palletName];

            if (manualWeight !== undefined) {
              // Use manually edited weight and preserve it for Mix Pallets only
              sumFinal = manualWeight;
            } else if (totalWeight[index] === undefined) {
              sumFinal = sum;
            } else {
              if (sum > totalWeight[index]) {
                totalWeight[index] = sum;
                sumFinal = sum;
              } else {
                sum = totalWeight[index];
                sumFinal = totalWeight[index];
              }
            }
          } else {
            // Handle regular PALLET type - use pallet weight directly, no total calculation needed
            const manualPalletWeight = manuallyEditedPalletWeights[palletName];

            if (manualPalletWeight !== undefined) {
              // Use manually edited weight for regular pallets only
              sumFinal = manualPalletWeight;
            } else {
              // For regular PALLET type, use the pallet weight directly from dimensions
              sumFinal = dimensions.palletWeight || 0;
            }
          }

          // On initial load, use original weight if available (applies to both types independently)
          if (initialLoad) {
            if (sum <= dimensions.palletWeight) {
              sumFinal = dimensions.palletWeight;
            } else {
              sumFinal = sum;
            }
            setInitialLoad(false);
          }
          // Check if this pallet has a manually edited weight for the dimension row
          const manualWeightForDimension = manuallyEditedWeights[palletName];
          const finalWeightForDimension =
            manualWeightForDimension !== undefined
              ? manualWeightForDimension
              : sumFinal;
          groupedData.push({
            key: `${palletName}-dimensions`,
            palletType: pallets[0].palletType,
            palletName: pallets[0].palletName,
            isDimensionsRow: true,
            length: dimensions.palletLength || 0,
            width: dimensions.palletWidth || 0,
            height: dimensions.palletHeight || 0,
            weight:
              pallets[0].palletType === "MIXPALLET"
                ? finalWeightForDimension
                : 0,
            isEditableRow: pallets[0].palletType === "MIXPALLET",
            index: index,
            totalWeightTransform: palletWeightTransform, // Use the pallet-specific array
            totalWeight: !totalWeightChange
              ? finalWeightForDimension
              : pallets[0].totalWeight === undefined
              ? finalWeightForDimension
              : pallets[0].totalWeight,
          });

          const weightData: Array<any> = totalWeight;

          // Handle weight data independently for each pallet type
          if (pallets[0].palletType === "MIXPALLET") {
            // Check if this Mix Pallet has a manually edited weight
            const manualWeight = manuallyEditedWeights[palletName];

            if (manualWeight !== undefined) {
              // Use manually edited weight for Mix Pallets only
              weightData[index] = manualWeight;
            } else {
              weightData[index] = !totalWeightChange
                ? sumFinal
                : pallets[0].totalWeight === undefined
                ? sumFinal
                : pallets[0].totalWeight;
            }
          } else {
            // Handle regular PALLET type - use pallet weight directly, no total calculation needed
            const manualPalletWeight = manuallyEditedPalletWeights[palletName];

            if (manualPalletWeight !== undefined) {
              // Use manually edited weight for regular Pallets only
              weightData[index] = manualPalletWeight;
            } else {
              // For regular PALLET type, use the pallet weight directly from dimensions
              const dimensions = pallets[0]?.palletDimensions || {};
              weightData[index] = dimensions.palletWeight || 0;
            }
          }

          setTotalWeight(weightData);
          sum = 0;
          totalsum = 0;
        }
      );
      setTotalWeightChange(false);

      let index = 0;
      groupedData.map((x: any) => {
        if (x.palletType === "MIXPALLET") {
          if (x.isDimensionsRow) {
            index++;
          } else {
            // Check if this Mix Pallet has a manually edited weight (independent from regular pallets)
            if (
              index > 0 &&
              x?.palletName === groupedData[index - 1]?.palletName
            ) {
              // Skip duplicate pallet names
            } else {
              const manualWeight = manuallyEditedWeights[x.palletName];
              x.palletDimensions.palletWeight =
                manualWeight !== undefined ? manualWeight : totalWeight[index];
            }
          }
        } else if (x.palletType === "PALLET") {
          // Handle regular PALLET type - use pallet weight directly, no total calculation needed
          if (x.isDimensionsRow) {
            index++;
          } else {
            // Check if this regular Pallet has a manually edited weight (independent from mix pallets)
            const manualPalletWeight =
              manuallyEditedPalletWeights[x.palletName];
            if (x.palletDimensions) {
              x.palletDimensions.palletWeight =
                manualPalletWeight !== undefined
                  ? manualPalletWeight
                  : x.palletDimensions.palletWeight || 0; // Use existing pallet weight directly
            }
          }
        }
        return x;
      });

      setTransformedData(groupedData);
    }
  }, [tableData, manuallyEditedWeights, manuallyEditedPalletWeights]);

  useEffect(() => {
    if (items.length && tableData.length) {
      const response = getItemWiseData(items, tableData);
      setFinalItemStatus(response);
    }
  }, [items, tableData]);

  return (
    <div className="shipment-table">
      <div className="shipment-table__wrapper">
        <SearchAndFilter
          // salesOrders={selectedShippingOrder}
          onOrderClick={handleOrderClick}
          isOrderStatusModalOpen={isOrderStatusModalOpen}
          onOrderStatusModalClose={handleOrderStatusModalClose}
          onClick={showModal}
          onSaveAndDraft={handleSaveAndDraft}
          packageId={packageId}
          palletsLength={transformedData.length}
          // createPackingList={createPackingListHandler}
          handlePackingList={handlePackingList}
          isSaveAndDraftLoading={isSaveAndDraftLoading}
          finalItemStatus={finalItemStatus}
          isCreatePackingLoading={isCreatePackingLoading}
          discrepancies={discrepancies}
          isDiscrepancyModalOpen={isDiscrepancyModalOpen}
          handleCreatePackingList={handleCreatePackingList}
          handleCancelDiscrepancy={handleCancelDiscrepancy}
          handleConfirmDiscrepancy={handleConfirmDiscrepancy}
          fetchItems={fetchItems}
        />

        <Table
          dataSource={transformedData}
          columns={columns}
          loading={
            palletsLoading || isSaveAndDraftLoading || isCreatePackingLoading
          }
          rowKey={(record) => record.id}
          scroll={{ y: "calc(100vh - 250px)" }}
          className="shipping-table"
          pagination={false}
          expandable={{
            expandedRowRender: getExpandedRowRender,
            expandedRowKeys,
            onExpand: handleExpand,
            rowExpandable: (record) => !record.isDimensionsRow,
          }}
          rowClassName={(record) =>
            record.isDimensionsRow ? "dimensions-row" : ""
          }
        />
      </div>

      <PalletTypeModal
        isPalletTypeModalOpen={isPalletTypeModalOpen}
        onCancel={closeModal}
        onSave={onSavePalletType}
      />

      <ConfirmDelete
        handleCancel={handleCancel}
        handleOk={handleOk}
        isModalOpen={isModalOpen}
        deleteHandler={deleteHandler}
        isAddUserLoading={isDeleteLoading}
      />
    </div>
  );
};

export default ShippingModal;
